/* CureFood — scripts du thème (vanilla, chargé en différé) */
(function () {
  'use strict';
  var CF = window.CF || {};
  var d = document;
  var $ = function (s, r) { return (r || d).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); };

  /* ---------- Utilitaires ---------- */
  function money(cents) {
    var fmt = CF.moneyFormat || 'CHF {{amount}}';
    var v = (Number(cents) || 0) / 100;
    var fixed = v.toFixed(2);
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, fixed.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(v))
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/, fixed.replace(/\B(?=(\d{3})+(?!\d))/g, "'"))
      .replace(/\{\{\s*amount\s*\}\}/, fixed)
      .replace(/<[^>]*>/g, '');
  }
  function toast(msg) {
    var t = $('.cf-toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(toast._t); toast._t = setTimeout(function () { t.hidden = true; }, 2400);
  }
  function lockFocus(el, on) { if (on) { var f = $('button', el) || $('a, input', el); if (f) f.focus({ preventScroll: true }); } }
  function esc(s) { return String(s || '').replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  /* ---------- Menu mobile ---------- */
  var menu = $('[data-cf-menu]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    $$('[data-cf-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    d.documentElement.style.overflow = open ? 'hidden' : '';
    lockFocus(menu, open);
  }
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-cf-menu-open]')) { e.preventDefault(); setMenu(true); }
    if (e.target.closest('[data-cf-menu-close]')) { e.preventDefault(); setMenu(false); }
  });

  /* ---------- Recherche prédictive ---------- */
  var search = $('[data-cf-search]');
  function setSearch(open) {
    if (!search) return;
    search.hidden = !open;
    d.documentElement.style.overflow = open ? 'hidden' : '';
    if (open) { var i = $('input[type=search]', search); if (i) setTimeout(function () { i.focus(); }, 30); }
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cf-search-open]');
    if (o && search) { e.preventDefault(); setSearch(true); }
    if (e.target.closest('[data-cf-search-close]')) { e.preventDefault(); setSearch(false); }
  });
  $$('[data-cf-predictive]').forEach(function (input) {
    var box = d.getElementById(input.getAttribute('aria-controls'));
    var timer, ctrl;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      if (q.length < 2) { if (box) { box.hidden = true; box.innerHTML = ''; } return; }
      timer = setTimeout(function () {
        if (ctrl) ctrl.abort();
        ctrl = 'AbortController' in window ? new AbortController() : null;
        var url = CF.routes.predictive + '?q=' + encodeURIComponent(q) +
          '&section_id=predictive-search&resources[type]=product,article,page&resources[limit]=6&resources[options][fields]=title,product_type,variants.title,tag,body';
        fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var res = doc.querySelector('[data-cf-predictive-results]');
          if (box && res) { box.innerHTML = res.innerHTML; box.hidden = false; }
        }).catch(function () {});
      }, 220);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Escape') { if (box) box.hidden = true; setSearch(false); } });
  });

  /* ---------- Panier tiroir ---------- */
  var root = d.documentElement;
  function cartEl() { return $('[data-cf-cart]'); }
  function openCart() { root.classList.add('cf-cart-open'); var c = cartEl(); if (c) { c.setAttribute('aria-hidden', 'false'); lockFocus(c, true); } loadRecs(); }
  function closeCart() { root.classList.remove('cf-cart-open'); var c = cartEl(); if (c) c.setAttribute('aria-hidden', 'true'); }
  d.addEventListener('click', function (e) {
    if (e.target.closest('[data-cf-cart-open]') && cartEl()) { e.preventDefault(); openCart(); }
    if (e.target.closest('[data-cf-cart-close]')) { e.preventDefault(); closeCart(); }
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeCart(); setMenu(false); setSearch(false); } });

  function renderSections(sections) {
    if (!sections) return;
    var html = sections['cart-drawer'];
    if (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var inner = doc.querySelector('[data-cf-cart-inner]');
      var cur = $('[data-cf-cart-inner]');
      if (inner && cur) cur.innerHTML = inner.innerHTML;
      var cnt = doc.querySelector('[data-cf-count]');
      if (cnt) updateCount(parseInt(cnt.getAttribute('data-cf-count'), 10) || 0);
    }
  }
  function updateCount(n) {
    $$('[data-cf-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0 && el.classList.contains('cf-badge'); });
  }
  function cartPost(url, body) {
    body.sections = 'cart-drawer';
    body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function addToCart(items, btn) {
    if (btn) btn.classList.add('is-loading');
    return cartPost(CF.routes.cartAdd + '.js', { items: items }).then(function (res) {
      renderSections(res.sections);
      toast(CF.strings.added);
      if (cartEl()) openCart(); else window.location.href = CF.routes.cart;
    }).catch(function (err) {
      toast((err && (err.description || err.message)) || CF.strings.error);
    }).then(function () { if (btn) btn.classList.remove('is-loading'); });
  }
  // Formulaires produit
  d.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cf-add]');
    if (!form) return;
    e.preventDefault();
    var fd = new FormData(form);
    var items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }];
    addToCart(items, form.querySelector('[type=submit]'));
  });
  // Ajout rapide
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cf-quick-add]');
    if (!b) return;
    e.preventDefault();
    var ids = String(b.getAttribute('data-cf-quick-add')).split(',').filter(Boolean);
    addToCart(ids.map(function (id) { return { id: Number(id), quantity: 1 }; }), b);
  });
  // Quantités dans le panier
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cf-line]');
    if (!b) return;
    e.preventDefault();
    var inner = $('[data-cf-cart-inner]'); if (inner) inner.classList.add('is-loading');
    cartPost(CF.routes.cartChange + '.js', { line: Number(b.getAttribute('data-cf-line')), quantity: Number(b.getAttribute('data-cf-qty')) })
      .then(function (res) { renderSections(res.sections); loadRecs(); })
      .catch(function () { toast(CF.strings.error); })
      .then(function () { var i = $('[data-cf-cart-inner]'); if (i) i.classList.remove('is-loading'); });
  });

  /* Suggestions intelligentes : produit qui débloque la livraison + « complétez votre rituel » */
  function loadRecs() {
    var box = $('[data-cf-recs]');
    if (!box || box.getAttribute('data-loaded') === box.getAttribute('data-key')) return;
    box.setAttribute('data-loaded', box.getAttribute('data-key'));
    var pid = box.getAttribute('data-product-id');
    var gap = Number(box.getAttribute('data-gap') || 0);
    var inCart = (box.getAttribute('data-in-cart') || '').split(',');
    var fallback = box.getAttribute('data-fallback');
    var reqs = [];
    if (pid) {
      reqs.push(fetch(CF.routes.recommendations + '.json?product_id=' + pid + '&limit=10&intent=complementary').then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }));
      reqs.push(fetch(CF.routes.recommendations + '.json?product_id=' + pid + '&limit=10&intent=related').then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }));
    }
    if (fallback) reqs.push(fetch(fallback + '/products.json?limit=20').then(function (r) { return r.json(); }).catch(function () { return { products: [] }; }));
    Promise.all(reqs).then(function (lists) {
      var seen = {}, pool = [];
      lists.forEach(function (l, li) {
        (l.products || []).forEach(function (p) {
          if (seen[p.id] || inCart.indexOf(String(p.id)) >= 0) return;
          var v = (p.variants || []).filter(function (x) { return x.available; })[0];
          if (!v) return;
          seen[p.id] = 1;
          var price = typeof v.price === 'string' ? Math.round(parseFloat(v.price) * 100) : v.price;
          var img = p.featured_image || (p.images && p.images[0] && (p.images[0].src || p.images[0])) || '';
          pool.push({ id: p.id, title: p.title, url: p.url || ('/products/' + p.handle), price: price, variant: v.id, img: img, pair: li < 2 });
        });
      });
      var fill = null;
      if (gap > 0) {
        var ok = pool.filter(function (p) { return p.price >= gap; }).sort(function (a, b) { return (b.pair - a.pair) || (a.price - b.price); });
        fill = ok[0] || null;
      }
      var html = '';
      if (fill) {
        html += '<div class="cf-filler"><span style="width:44px;height:64px;border-radius:10px;overflow:hidden;background:#EFE7DA;flex:none">' +
          (fill.img ? '<img src="' + esc(img(fill.img, 120)) + '" alt="" width="88" height="128" loading="lazy" style="width:100%;height:100%;object-fit:cover">' : '') +
          '</span><span style="flex:1;min-width:0;display:flex;flex-direction:column;line-height:1.25"><span class="cf-mono" style="font-size:10px;color:#2F7A1C">' + esc(CF.strings.unlocks) + '</span><span style="font-weight:600;font-size:14px">' + esc(fill.title) +
          '</span></span><button type="button" class="cf-btn cf-btn--dark cf-btn--sm" data-cf-quick-add="' + fill.variant + '">+ ' + esc(money(fill.price)) + '</button></div>';
      }
      var sugg = pool.filter(function (p) { return !fill || p.id !== fill.id; }).slice(0, 4);
      if (sugg.length) {
        html += '<div style="display:flex;flex-direction:column;gap:10px;padding-top:4px"><h3 style="font-size:17px;letter-spacing:-.02em">' + esc(box.getAttribute('data-title')) + '</h3><div class="cf-row">';
        sugg.forEach(function (p) {
          html += '<div class="cf-sugg"><a class="cf-sugg__img" href="' + esc(p.url) + '">' + (p.img ? '<img src="' + esc(img(p.img, 300)) + '" alt="' + esc(p.title) + '" width="276" height="414" loading="lazy">' : '') + '</a>' +
            '<span style="padding:0 3px;font-weight:600;font-size:13px;line-height:1.2">' + esc(p.title) + '</span>' +
            '<button type="button" class="cf-btn cf-btn--dark cf-btn--sm" style="min-height:38px;font-size:12px" data-cf-quick-add="' + p.variant + '">+ ' + esc(money(p.price)) + '</button></div>';
        });
        html += '</div></div>';
      }
      box.innerHTML = html;
    });
  }
  function img(src, w) {
    src = String(src);
    if (src.indexOf('//') === 0) src = 'https:' + src;
    try { var u = new URL(src, window.location.origin); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  }

  /* ---------- Page produit ---------- */
  $$('[data-cf-product]').forEach(function (wrap) {
    var form = $('form[data-cf-add]', wrap);
    var idInput = form && $('input[name=id]', form);
    var priceEls = $$('[data-cf-price]', d);
    var ctaEls = $$('[data-cf-cta]', d);
    var qty = $('input[name=quantity]', wrap);
    function currentPrice() {
      var r = $('input[name=cf-variant]:checked', wrap);
      return r ? Number(r.getAttribute('data-price')) : Number(wrap.getAttribute('data-price'));
    }
    function refresh() {
      var p = currentPrice() * (qty ? Math.max(1, Number(qty.value) || 1) : 1);
      priceEls.forEach(function (el) { el.textContent = money(currentPrice()); });
      ctaEls.forEach(function (el) { var sp = el.querySelector('[data-cf-cta-price]'); if (sp) sp.textContent = money(p); else el.textContent = (el.getAttribute('data-label') || CF.strings.add) + ' · ' + money(p); });
      var bar = $('[data-cf-ship-bar]', wrap), msg = $('[data-cf-ship-msg]', wrap);
      if (bar && CF.freeShipping) {
        var pct = Math.min(100, Math.round(p / CF.freeShipping * 100));
        bar.style.width = Math.max(4, pct) + '%';
        if (msg) msg.textContent = p >= CF.freeShipping ? CF.strings.freeShippingDone : CF.strings.freeShippingLeft.replace('[amount]', money(CF.freeShipping - p));
      }
    }
    $$('input[name=cf-variant]', wrap).forEach(function (r) {
      r.addEventListener('change', function () {
        if (idInput) idInput.value = r.value;
        var u = new URL(window.location.href); u.searchParams.set('variant', r.value); history.replaceState(null, '', u.toString());
        var mi = r.getAttribute('data-media');
        if (mi) showMedia(mi);
        refresh();
      });
    });
    $$('[data-cf-qty-step]', wrap).forEach(function (b) {
      b.addEventListener('click', function () { qty.value = Math.max(1, (Number(qty.value) || 1) + Number(b.getAttribute('data-cf-qty-step'))); refresh(); });
    });
    if (qty) qty.addEventListener('change', refresh);
    // Galerie
    var main = $('[data-cf-gallery-main]', wrap);
    function showMedia(id) {
      var t = $('[data-cf-thumb="' + id + '"]', wrap);
      if (!t || !main) return;
      var im = $('img', main);
      im.src = t.getAttribute('data-src'); im.srcset = t.getAttribute('data-srcset') || ''; im.alt = t.getAttribute('data-alt') || '';
      main.classList.toggle('is-wide', t.getAttribute('data-wide') === '1');
      $$('[data-cf-thumb]', wrap).forEach(function (x) { x.setAttribute('aria-current', x === t ? 'true' : 'false'); });
      var c = $('[data-cf-gallery-count]', wrap); if (c) c.textContent = t.getAttribute('data-index') + ' / ' + $$('[data-cf-thumb]', wrap).length;
    }
    $$('[data-cf-thumb]', wrap).forEach(function (t) { t.addEventListener('click', function () { showMedia(t.getAttribute('data-cf-thumb')); }); });
    // Barre d’achat collante (mobile)
    var sticky = $('[data-cf-sticky-atc]');
    var anchor = form && $('[type=submit]', form);
    if (sticky && anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(anchor);
      sticky.addEventListener('click', function (e) { if (e.target.closest('[data-cf-sticky-buy]')) { e.preventDefault(); form.requestSubmit ? form.requestSubmit() : form.submit(); } });
    }
    refresh();
  });

  /* ---------- Recommandations produit (rendu de section) ---------- */
  $$('[data-cf-recs-url]').forEach(function (el) {
    var load = function () {
      fetch(el.getAttribute('data-cf-recs-url')).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-cf-recs-url]');
        if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML; else el.remove();
      }).catch(function () {});
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { io.disconnect(); load(); } }, { rootMargin: '400px' });
      io.observe(el);
    } else load();
  });

  /* ---------- Onglets (rituels, profils, documents) ---------- */
  $$('[data-cf-tabs]').forEach(function (tabs) {
    var btns = $$('[role=tab]', tabs);
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        btns.forEach(function (x) {
          var on = x === b;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.style.background = on ? (x.getAttribute('data-bg') || '') : '';
          var p = d.getElementById(x.getAttribute('aria-controls'));
          if (p) p.hidden = !on;
        });
      });
    });
  });

  /* ---------- Recette : portions + mode cuisine ---------- */
  $$('[data-cf-recipe]').forEach(function (r) {
    var base = Number(r.getAttribute('data-base')) || 1;
    var serv = base;
    var unit1 = r.getAttribute('data-unit') || '', unitN = r.getAttribute('data-units') || unit1;
    var out = $('[data-cf-serv]', r);
    var PLU = { 'pincée': 'pincées', 'poignée': 'poignées', 'gousse': 'gousses', 'sachet': 'sachets' };
    function frac(x) {
      var q = Math.round(x * 4) / 4; if (q === 0) q = 0.25;
      var w = Math.floor(q), f = q - w;
      var s = f === 0.25 ? '¼' : f === 0.5 ? '½' : f === 0.75 ? '¾' : '';
      return (w ? String(w) : '') + (w && s ? ' ' : '') + s;
    }
    function draw() {
      var k = serv / base;
      if (out) out.textContent = serv + ' ' + (serv > 1 ? unitN : unit1);
      $$('[data-q]', r).forEach(function (el) {
        var q = parseFloat(el.getAttribute('data-q')); if (isNaN(q)) return;
        var u = el.getAttribute('data-u') || '', v = q * k, txt;
        if (u === 'g' || u === 'ml') txt = (v >= 50 ? Math.round(v / 5) * 5 : Math.round(v)) + ' ' + u;
        else if (u === 'l') txt = String(Math.round(v * 10) / 10).replace('.', ',') + ' l';
        else { var many = Math.round(v * 4) / 4 > 1; txt = frac(v) + (u ? ' ' + (many && PLU[u] ? PLU[u] : u) : ''); }
        var qEl = $('[data-qty]', el); if (qEl) qEl.textContent = txt;
        var lEl = $('[data-label]', el);
        if (lEl && el.getAttribute('data-p')) lEl.textContent = (u === '' && Math.round(v * 4) / 4 > 1) ? el.getAttribute('data-p') : el.getAttribute('data-s');
      });
    }
    $$('[data-cf-serv-step]', r).forEach(function (b) {
      b.addEventListener('click', function () { serv = Math.min(12, Math.max(1, serv + Number(b.getAttribute('data-cf-serv-step')))); draw(); });
    });
    var steps = $$('[data-cf-step]', r), cur = 0;
    function drawSteps() {
      steps.forEach(function (s, i) { s.classList.toggle('is-current', i === cur); s.classList.toggle('is-done', i < cur); });
      var n = $('[data-cf-step-now]', r); if (n) n.textContent = Math.min(cur + 1, steps.length);
      var bar = $('[data-cf-step-bar]', r); if (bar) bar.style.width = Math.round(Math.min(cur + 1, steps.length) / steps.length * 100) + '%';
    }
    steps.forEach(function (s, i) { s.addEventListener('click', function () { cur = i; drawSteps(); }); });
    var nx = $('[data-cf-step-next]', r), pv = $('[data-cf-step-prev]', r);
    if (nx) nx.addEventListener('click', function () { cur = Math.min(steps.length, cur + 1); drawSteps(); });
    if (pv) pv.addEventListener('click', function () { cur = Math.max(0, cur - 1); drawSteps(); });
    draw(); if (steps.length) drawSteps();
  });

  /* ---------- Filtres collection ---------- */
  $$('form[data-cf-filters]').forEach(function (f) {
    f.addEventListener('change', function () {
      var p = new URLSearchParams(new FormData(f));
      Array.from(p.keys()).forEach(function (k) { if (p.get(k) === '') p.delete(k); });
      window.location.search = p.toString();
    });
  });

  /* ---------- Pied de page : colonnes ouvertes sur ordinateur ---------- */
  if (window.matchMedia('(min-width: 750px)').matches) { $$('.cf-footer__col').forEach(function (x) { x.open = true; }); }

  /* ---------- Partage ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-cf-share]');
    if (!b) return;
    e.preventDefault();
    if (navigator.share) { navigator.share({ title: d.title, url: window.location.href }).catch(function () {}); }
    else if (navigator.clipboard) { navigator.clipboard.writeText(window.location.href).then(function () { toast(b.getAttribute('data-copied') || 'OK'); }); }
  });
  d.addEventListener('click', function (e) { if (e.target.closest('[data-cf-print]')) { e.preventDefault(); window.print(); } });
})();

/* ---------- Page Recettes : filtres par moment + recette affichée en haut ---------- */
(function () {
  var root = document.querySelector('[data-cf-recipes]');
  if (!root) return;
  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-cf-rpick]'));
  var panels = Array.prototype.slice.call(root.querySelectorAll('[data-cf-rpanel]'));
  function show(slug, scroll) {
    var p = root.querySelector('[data-cf-rpanel="' + slug + '"]');
    if (!p) return;
    panels.forEach(function (x) { x.hidden = x !== p; });
    cards.forEach(function (c) { c.setAttribute('aria-current', c.getAttribute('data-cf-rpick') === slug ? 'true' : 'false'); });
    if (scroll) p.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  cards.forEach(function (c) {
    c.addEventListener('click', function (e) {
      e.preventDefault();
      var slug = c.getAttribute('data-cf-rpick');
      history.replaceState(null, '', location.pathname + location.search + '#r-' + slug);
      show(slug, true);
    });
  });
  var count = root.querySelector('[data-cf-rcount]');
  root.querySelectorAll('[data-cf-rfilter]').forEach(function (b) {
    b.addEventListener('click', function () {
      var m = b.getAttribute('data-cf-rfilter'), n = 0;
      root.querySelectorAll('[data-cf-rfilter]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      cards.forEach(function (c) { var on = m === 'all' || c.getAttribute('data-m') === m; c.hidden = !on; if (on) n++; });
      if (count) count.textContent = count.getAttribute('data-tpl').replace('[count]', n);
    });
  });
  var h = location.hash.replace('#r-', '');
  if (h && h !== location.hash) show(h, true); else if (cards[0]) cards[0].setAttribute('aria-current', 'true');
})();
